module.exports = __webpack_public_path__ + "assets/scoober-logo-desktop-he-005d22.svg";